import AnalyticsService from '@ajs/services/AnalyticsService';
import LogService from '@ajs/services/LogService';
import NavigationService from '@ajs/services/NavigationService';
import { TransitionService } from '@uirouter/angularjs';
import { Transition } from '@uirouter/core/lib/transition/transition';
import { ILocationService } from 'angular';
import FdxError from '../models/FdxError';
import { fdxUI as FdxUI } from '@ajs/services/fdxUI';

function transitionsHandler(
    $transitions: TransitionService,
    $location: ILocationService,
    fdxUI: FdxUI,
    logService: LogService,
    navigationService: NavigationService,
    analyticsService: AnalyticsService
): void {

    function handleRejections(transition: Transition): void {

        const error = transition.error();

        const rejectionData = error.detail;

        if (rejectionData === 'Not Logged In') {
            navigationService.redirectToLogin();
        }

        if (rejectionData instanceof FdxError) {

            switch (rejectionData.key) { // Add more as needed

                case 'ACCOUNT_INSUFFICIENT_PERMISSION':
                case 'USER_HAS_MULTIPLE_ACCOUNTS':
                case 'USER_HAS_NO_ACCOUNT':
                    navigationService.handleSelectAccount();
                    break;

                case 'DATABASE_INSUFFICIENT_PERMISSION':
                    $location.path('databases');
                    break;

                default:
                    logService.error('transitionsHandler', 'handleRejections', error.message);
                    break;
            }

        } else {
            logService.error('transitionsHandler', 'handleRejections', error.message);
        }

    }

    $transitions.onStart({}, (transition) => {
        if (navigationService.isLoginPendingRestore()) {
            navigationService.restoreAfterLogin();
        }

        if (transition.to().name !== 'app.accounts') {
            if (navigationService.isAccountSelectionPendingRestore()) {
                navigationService.restoreAfterAccountSelection();
            }
        }

        if (transition.to().name === 'app.auth_redirect') {
            navigationService.redirectToLogin();
        }

    });

    $transitions.onError({}, (transition) => {
        handleRejections(transition);
    });

    $transitions.onEnter({}, (transition) => {
        analyticsService.identify();

        if (fdxUI.showMinimalEbayUI()) {
            const transitionTo = transition.to();
            if (transitionTo.data?.allowEbay !== true) {
                return transition.router.stateService.target('app.ebay-selection');
            }
        }
    });

}

transitionsHandler.$inject = ['$transitions', '$location', 'fdxUI', 'LogService', 'NavigationService', 'AnalyticsService']

export { transitionsHandler };
